(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    const initializeStickyAtc = (root) => {
    if (root.dataset.initialized === 'true') return;

    const formId = root.dataset.productFormId;
    const sectionId = root.dataset.sectionId;

    if (formId?.includes('quickadd') || sectionId?.includes('quickadd')) {
      root.remove();
      return;
    }

    const originalForm = document.getElementById(formId);
    const originalButton = document.getElementById('ProductSubmitButton-' + sectionId);
    const stickyButton = root.querySelector('[data-sticky-atc-button]');
    const stickyLabel = root.querySelector('[data-sticky-atc-label]');
    const stickyTiers = root.querySelector('[data-sticky-atc-tiers]');
    const stickyTierButtons = [...root.querySelectorAll('[data-sticky-tier-index]')];
    const stickyPrice = root.querySelector('[data-sticky-atc-price]');
    const stickySaving = root.querySelector('[data-sticky-atc-saving]');
    const stickyUnit = root.querySelector('[data-sticky-atc-unit]');
    const section =
      originalButton?.closest('.shopify-section') ||
      originalButton?.closest('section');
    const footer = document.querySelector(
      'footer, .footer, .shopify-section-group-footer-group'
    );

    if (!originalForm || !originalButton || !stickyButton || !section) return;

    root.dataset.initialized = 'true';

    const originalStyle = getComputedStyle(originalButton);
    const originalHeight = originalButton.getBoundingClientRect().height;

    if (originalHeight > 0) {
      root.style.setProperty('--snusbox-sticky-button-height', originalHeight + 'px');
    }

    root.style.setProperty('--snusbox-sticky-button-radius', originalStyle.borderRadius);
    root.style.setProperty('--snusbox-sticky-button-background', originalStyle.backgroundColor);
    root.style.setProperty('--snusbox-sticky-button-color', originalStyle.color);
    root.style.setProperty('--snusbox-sticky-button-font-size', originalStyle.fontSize);
    root.style.setProperty('--snusbox-sticky-button-font-weight', originalStyle.fontWeight);

    const firstVisibleTrigger = (selector, scope = document) =>
      [...scope.querySelectorAll(selector)].find(
        (item) => item.offsetParent !== null
      );
    const recommendedTrigger = firstVisibleTrigger(
      '.snus-recommended-products--mobile'
    );
    const specsTrigger =
      firstVisibleTrigger('.snus-specs', section) ||
      firstVisibleTrigger('.snus-specs');
    const trigger = recommendedTrigger || specsTrigger;

    document.body.append(root);

    const visiblePresets = () =>
      [...section.querySelectorAll('.quantity-preset')].filter(
        (item) => item.offsetParent !== null
      );

    const firstVisible = (selector) =>
      [...section.querySelectorAll(selector)].find(
        (item) => item.offsetParent !== null
      );

    const moneyFormatter = (displayedPrice) => {
      const symbol = displayedPrice.match(/[^\d\s.,-]+/)?.[0] || '€';
      const currencyFirst = displayedPrice.trim().startsWith(symbol);

      return (amount) => {
        const number = (amount / 100).toLocaleString(
          document.documentElement.lang || 'de-DE',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        );

        return currencyFirst ? symbol + number : number + ' ' + symbol;
      };
    };

    let frameRequested = false;

    const interfaceOverlayOpen = () =>
      Boolean(
        document.querySelector(
          '#Details-menu-drawer-container[open], cart-drawer.active, cart-drawer[open], quick-add-modal[open], quick-add-modal.active, details-modal details[open], product-modal[open], product-modal[aria-hidden="false"]'
        )
      );

    const triggerHasBeenReached = () => {
      if (!trigger || trigger.offsetParent === null) return true;

      const triggerRect = trigger.getBoundingClientRect();
      const boundary = trigger.matches('.snus-specs')
        ? triggerRect.bottom
        : triggerRect.top;

      return boundary <= window.innerHeight;
    };

    const updateVisibility = () => {
      const originalRect = originalButton.getBoundingClientRect();
      const footerRect = footer?.getBoundingClientRect();
      const footerBlocksDock =
        footerRect &&
        footerRect.top < window.innerHeight &&
        footerRect.bottom > 0;
      const visible =
        window.matchMedia('(max-width: 749px)').matches &&
        originalRect.bottom < 0 &&
        triggerHasBeenReached() &&
        !footerBlocksDock &&
        !interfaceOverlayOpen() &&
        !stickyButton.disabled;

      root.classList.toggle('is-visible', visible);
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      frameRequested = false;
    };

    const requestVisibilityUpdate = () => {
      if (frameRequested) return;

      frameRequested = true;
      requestAnimationFrame(updateVisibility);
    };

    const sync = () => {
      const presets = visiblePresets();
      const activePreset = presets.find((item) =>
        item.classList.contains('is-active')
      );
      const activeIndex = Math.max(0, presets.indexOf(activePreset));
      const totalElement = section.querySelector('.js-qty-total');
      const quantityInput = firstVisible('input[name="quantity"]');
      const displayedPrice =
        totalElement?.textContent.trim() ||
        firstVisible('[id="price-' + sectionId + '"] .price-item--sale')?.textContent.trim() ||
        firstVisible('[id="price-' + sectionId + '"] .price-item--regular')?.textContent.trim() ||
        '';
      const quantityText =
        activePreset?.textContent.trim().match(/\d+/)?.[0] ||
        quantityInput?.value ||
        '1';
      const quantity = Number.parseInt(quantityText, 10);
      const discountMatch = activePreset?.textContent.match(/-(\d+)%/);
      const discount = discountMatch
        ? Number.parseInt(discountMatch[1], 10)
        : 0;
      const basePrice = Number.parseInt(
        totalElement?.dataset.basePrice || '',
        10
      );
      const canCalculate =
        Number.isFinite(basePrice) &&
        Number.isFinite(quantity) &&
        quantity > 0;
      const unit = canCalculate
        ? Math.round((basePrice * (100 - discount)) / 100)
        : 0;
      const total = unit * quantity;
      const saving = canCalculate
        ? basePrice * quantity - total
        : 0;
      const formatMoney = moneyFormatter(displayedPrice);
      const savingsLabel = root.dataset.savingLabel || 'You save';
      const unitLabel = root.dataset.unitLabel || 'per can';
      const compactLabel = root.dataset.compactLabel || '';
      const isGerman = document.documentElement.lang
        .toLowerCase()
        .startsWith('de');
      const originalLabel =
        originalButton.querySelector(
          'span:not(.sold-out-message):not(.hidden)'
        ) ||
        originalButton.querySelector(
          '.sold-out-message:not(.hidden)'
        );
      const disabled =
        originalButton.disabled ||
        originalButton.getAttribute('aria-disabled') === 'true';

      stickyTiers.hidden = presets.length < 2;

      stickyTierButtons.forEach((button, index) => {
        const selected = index === activeIndex;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = !presets[index];
      });

      stickyPrice.textContent = canCalculate
        ? formatMoney(total)
        : displayedPrice;
      stickyUnit.textContent = canCalculate
        ? formatMoney(unit) + ' ' + unitLabel
        : '';

      const formattedSaving = saving > 0 ? formatMoney(saving) : '';
      const savingText =
        saving > 0 ? savingsLabel + ' ' + formattedSaving : '';

      stickySaving.textContent = savingText;
      stickySaving.setAttribute('aria-label', savingText);
      stickySaving.hidden = saving <= 0;

      if (originalLabel?.textContent.trim()) {
        stickyLabel.textContent =
          isGerman && !disabled && compactLabel
            ? compactLabel
            : originalLabel.textContent.trim();
      }

      stickyButton.disabled = disabled;
      stickyButton.setAttribute(
        'aria-disabled',
        disabled ? 'true' : 'false'
      );

      requestVisibilityUpdate();
    };

    stickyTierButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const preset = visiblePresets()[index];

        if (preset) preset.click();
        requestAnimationFrame(sync);
      });
    });

    stickyButton.addEventListener('click', () => {
      if (!stickyButton.disabled) originalButton.click();
    });

    new MutationObserver(sync).observe(section, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    section.addEventListener('change', () => requestAnimationFrame(sync));
    section.addEventListener('click', () => requestAnimationFrame(sync));
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });

    new MutationObserver(requestVisibilityUpdate).observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'open', 'aria-hidden']
    });

    requestAnimationFrame(sync);
    updateVisibility();
  };

  document
    .querySelectorAll('[data-sticky-atc]')
    .forEach(initializeStickyAtc);
  } catch(e) { console.error(e); }
})();

})();
